import { Component, Input } from '@angular/core';

export type BadgeVariant = 'blue' | 'green' | 'orange' | 'red' | 'gray' | 'purple' | 'cyan' | 'orange-rca' | 'green-rca';
export type BadgeSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'kt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = 'gray';
  @Input() size: BadgeSize = 'md';
  @Input() dot = false;
  @Input() icon = '';
  @Input() label = '';
  @Input() count: number | null = null;
  @Input() pill = true;
  @Input() bordered = false;
}
